export const traceTheme: Array<string> = [
    // Blue
    '#3792BF',
    // Light Blue
    '#AACCFF',
    // Dark Gray
    '#7D7979',
    // Green
    '#0CAD99',
    // Gray
    '#BDBDBD',
    // Navy Blue
    '#1B3E78',
    // Light green
    '#57f5e2'
]